import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    value: [],
};

export const announcementSlice = createSlice({
    name: "announcementSlice",
    initialState,
    reducers: {
        setUserAnnouncements: (state, action) => {
            state.value = action.payload;
        },
    },
});

export const { setUserAnnouncements } = announcementSlice.actions;

export default announcementSlice.reducer;
